export const breakpoints = {
  sm: "320px",
  "2sm": "380px",
  "3.5sm": "480px",
  "3sm": "600px",
  md: "800px",
  lg: "1000px",
  xl: "1200px",
  "1.5xl": "1400px",
  "2xl": "1600px",
  "3xl": "1920px",
};
